import "./WaveForm.scss";

const WaveForm = (): JSX.Element => <div className="WaveForm"></div>;

export default WaveForm;
